const filterLife = (filter) => {
  const {
    currentLifePercent,
  } = filter;

  const percent = currentLifePercent;

  if (percent !== null) {
    return percent;
  }

  return '';
};

export default filterLife;
